export const CREATE_ACCOUNT = 'managers/new'
export const UPDATE_ACCOUNT = 'managers/update'
export const UPDATE_PASSWORD = 'managers/password_update'
